import { optimizeImage } from './imageOptimizer'

export default function storageHandler(storage, state, key, level) {
  // (IMPORTANTE!) Variables para chequear a cuales secciones de imagenes
  // se les esta haciendo update (principal e imagenes de hero)
  const storageConfig = {
    carouselImageUpdate: null,
    localidadImageUpdate: null,
    heroImgsUpdate: [],
    contenidoCulturaUpdates: []
  }
  // La imagenes que se agreguen para el update seran guardadas en un objeto
  // (state.zonaImgsToSave | contenidoCulturaBorrador) que servira como borrador, las propiedades de imagenes
  // en el estado de zona (state.zona) no se modificaran para mostrar en la plantilla las
  // imagenes que ya han sido previamente guardadas

  // Deconstructing y creacion de promesa de la imagen principal
  var { carouselImg, carouselImgUrl } = state.trip.viajeImgsToSave
  if (carouselImg && carouselImgUrl) {
    const carouselImgUploadTask = (async function () {
      const opt = await optimizeImage(carouselImg)
      let carouselImgUploadString
      switch (level) {
        case 'trip':
          carouselImgUploadString = `viajes/${key}/main${opt.extension}`
          break
        default:
          break
      }
      const carouselImgUploadPointer = storage.ref().child(carouselImgUploadString)
      return carouselImgUploadPointer.put(opt.blob)
    })()
    storageConfig.carouselImageUpdate = carouselImgUploadTask
  }

  var { carouselImg, carouselImgUrl } = state.zonaImgsToSave
  if (carouselImg && carouselImgUrl) {
    const carouselImgUploadTask = (async function () {
      const opt = await optimizeImage(carouselImg)
      let carouselImgUploadString
      switch (level) {
        case 'zona':
          carouselImgUploadString = `zonas/${key}/main${opt.extension}`
          break
        case 'destino':
          carouselImgUploadString = `zonas/${key.zonaId}/destinos/${key.destinoId}/main${opt.extension}`
          break
        case 'experiencia':
          carouselImgUploadString = `zonas/${key.zonaId}/destinos/${key.destinoId}/experiencias/${key.experienciaId}/main${opt.extension}`
          break
        default:
          break
      }
      const carouselImgUploadPointer = storage.ref().child(carouselImgUploadString)
      return carouselImgUploadPointer.put(opt.blob)
    })()
    storageConfig.carouselImageUpdate = carouselImgUploadTask
  }

  const { localidadImg, localidadImgUrl } = state.zonaImgsToSave
  if (localidadImg && localidadImgUrl) {
    const localidadImgUploadTask = (async function () {
      const opt = await optimizeImage(localidadImg)
      let localidadImgUploadString
      switch (level) {
        case 'zona':
          localidadImgUploadString = `zonas/${key}/localidad${opt.extension}`
          break
        case 'destino':
          localidadImgUploadString = `zonas/${key.zonaId}/destinos/${key.destinoId}/localidad${opt.extension}`
          break
        case 'experiencia':
          localidadImgUploadString = `zonas/${key.zonaId}/destinos/${key.destinoId}/experiencias/${key.experienciaId}/localidad${opt.extension}`
          break
        default:
          break
      }
      const localidadImgUploadPointer = storage.ref().child(localidadImgUploadString)
      return localidadImgUploadPointer.put(opt.blob)
    })()
    storageConfig.localidadImageUpdate = localidadImgUploadTask
  }

  const { heroImgs, heroImgUrls } = state.zonaImgsToSave
  if ((heroImgs.length > 0 && heroImgUrls.length > 0) && (heroImgs.length === heroImgUrls.length)) {
    const heroImagesUploadHandler = heroImgs.map((img, index) => {
      return (async function () {
        const opt = await optimizeImage(img)
        const newFileName = Math.floor(Math.random() * 100000000)
        let heroUploadString
        switch (level) {
          case 'zona':
            heroUploadString = `zonas/${key}/hero/${newFileName + opt.extension}`
            break
          case 'destino':
            heroUploadString = `zonas/${key.zonaId}/destinos/${key.destinoId}/hero/${newFileName + opt.extension}`
            break
          case 'experiencia':
            heroUploadString = `zonas/${key.zonaId}/destinos/${key.destinoId}/experiencias/${key.experienciaId}/hero/${newFileName + opt.extension}`
            break
          default:
            break
        }
        const heroUploadPointer = storage.ref().child(heroUploadString)
        return heroUploadPointer.put(opt.blob)
      })()
    })
    storageConfig.heroImgsUpdate = heroImagesUploadHandler
  }

  if (state.contenidoCulturaBorrador) {
    const { contenidoCulturaBorrador } = state
    const culturaImagesUploadHandler = contenidoCulturaBorrador.map((contenido) => {
      return (async function () {
        const opt = await optimizeImage(contenido.img)
        const newFileName = Math.floor(Math.random() * 100000000)
        let contenidoUploadString
        switch (level) {
          case 'zona':
            contenidoUploadString = `zonas/${key}/cultura-slideshow/${newFileName + opt.extension}`
            break
          case 'destino':
            contenidoUploadString = `zonas/${key.zonaId}/destinos/${key.destinoId}/cultura-slideshow/${newFileName + opt.extension}`
            break
          default:
            break
        }
        const contenidoUploadPointer = storage.ref().child(contenidoUploadString)
        return contenidoUploadPointer.put(opt.blob)
      })()
    })
    storageConfig.contenidoCulturaUpdates = culturaImagesUploadHandler
  }

  if (state.trip.itinerariosDias) {
    const { itinerariosDias } = state.trip
    const itinerarioImagesUploadHandler = itinerariosDias.map((contenido) => {
      if (contenido.img) {
        return (async function () {
          const opt = await optimizeImage(contenido.img)
          const newFileName = Math.floor(Math.random() * 100000000)
          let contenidoUploadString
          switch (level) {
            case 'trip':
              contenidoUploadString = `viajes/${key}/dias-itinerarios/${newFileName + opt.extension}`
              break
            default:
              break
          }
          const contenidoUploadPointer = storage.ref().child(contenidoUploadString)
          return contenidoUploadPointer.put(opt.blob)
        })()
      }
    })
    storageConfig.itinerarioDiasUpdates = itinerarioImagesUploadHandler
  }

  return storageConfig
}
